<script setup lang="ts">
import { computed } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { groupsApi } from '@/api/groups';
import { useGroupFilterStore } from '@/stores/group-filter';

const FIVE_MINUTES_IN_MS = 300_000;

const groupFilter = useGroupFilterStore();

const { data: groups } = useQuery({
  queryKey: ['groups', 'forFilters'],
  queryFn: () => groupsApi.indexForFilters(),
  staleTime: FIVE_MINUTES_IN_MS,
});

const active = computed(() => (groupFilter.groupIds?.length ?? 0) > 0);

const groupNames = computed(() => {
  const ids = new Set(groupFilter.groupIds ?? []);
  const names = (groups.value ?? [])
    .filter(g => ids.has(g.id))
    .map(g => g.name);

  return names.join(', ');
});

const groupCount = computed(() => groupFilter.groupIds?.length ?? 0);

function clear() {
  groupFilter.clear();
}
</script>

<template>
  <v-alert
    v-if="active"
    type="info"
    variant="tonal"
    density="compact"
    icon="mdi-filter-variant"
    class="mb-4"
  >
    <div class="d-flex align-center">
      <div class="flex-grow-1">
        Filtro Grupo activo: <strong>{{ groupNames }}</strong>.
        Sólo se muestran los pacientes y profesionales de
        {{ groupCount > 1 ? 'esos grupos' : 'ese grupo' }}.
      </div>
      <v-btn
        variant="text"
        size="small"
        @click="clear"
      >
        Quitar filtro
      </v-btn>
    </div>
  </v-alert>
</template>
